<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">제목</th>
							<td class="col-5"><el-input v-model="saveData.title" /></td>
							<th class="col-3">이미지1</th>
							<th class="col-3">이미지2</th>
						</tr>
						<tr>
							<th>불량내용</th>
							<td><el-input type="textarea" v-model="saveData.conts" maxlength="100" :rows="8" /></td>
							<td rowspan="2">
								<template v-if="!isLoaded">
									<img-upload
										width="100%"
										height="170px"
										:propSrc="saveData.imgId1Url"
										propSeq="imgFile1"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
									>
									</img-upload>
								</template>
							</td>
							<td rowspan="2">
								<template v-if="!isLoaded">
									<img-upload
										width="100%"
										height="170px"
										:propSrc="saveData.imgId2Url"
										propSeq="imgFile2"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
									></img-upload>
								</template>
							</td>
						</tr>
						<tr>
							<th>파일첨부</th>
							<td>
								<file-upload></file-upload>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@qms/Components/ImgUpload.vue';
import FileUpload from '@qms/Components/FileUpload.vue';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	data() {
		return {
			//isSaveFlag: false,
			isLoaded: false,
			// data: '',
			// date1: '',
			// input1: '',
			// textarea1: '',
			// title: '',
			// conts: '',
			// imgId1: {},
			// imgId2: {}

			saveData: {
				data: '',
				date1: '',
				input1: '',
				textarea1: '',
				title: '',
				conts: '',
				imgFile1: {},
				imgId1Url: '',
				imgFile2: {},
				imgId2Url: ''
			}
		};
	},
	watch: {
		chgFlag() {
			//console.log(this.getIsSaveFlag_);
			//console.log('2.변경여부 확인 >>>>> ', this.getIsSaveFlag_);

			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setState_({ key: 'saveDataObj3', value: this.saveData });
				//console.log('3.TableDetailInfo.vue chgFlag >>> ', this.getSaveDataObj3_);
			}
		}
	},
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		try {
			this.isLoaded = true;
			this.$sf_toggleLoading(true);
			this.saveData.title = this.resultObj_.gqmsTitle || '';
			this.saveData.conts = this.resultObj_.gqmsConts || '';
			const { url: img1 } = this.resultObj_.imgId1 ? await this.imgDownload_({ fileId: this.resultObj_.imgId1, fileSeq: 1 }) : '';
			const { url: img2 } = this.resultObj_.imgId2 ? await this.imgDownload_({ fileId: this.resultObj_.imgId2, fileSeq: 1 }) : '';
			this.saveData.imgId1Url = img1;
			this.saveData.imgId2Url = img2;
		} catch (error) {
		} finally {
			this.isLoaded = false;
			this.$sf_toggleLoading(false);
		}
	},
	components: { FileUpload, ImgUpload },
	computed: {
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...serviceMethods,
		imgUpload({ seq, file }) {
			//console.log('imgUpload', seq, file);
			if (seq == 'imgFile1') {
				this.saveData.imgFile1 = file;
			} else {
				this.saveData.imgFile2 = file;
			}
		},
		async imgDownload({ seq }) {
			await this.fileDownload_({ fileId: this.resultObj_[seq], fileSeq: 1 });
		}
	}
};
</script>

<style></style>
